import {createContext, ReactNode, useContext, useEffect} from 'react';

import {selectUser, useAppSelector} from '@/app/store';

import {useTrackers} from './trackers';

type ViewModelContextType = {
  trackSelectOnboardingKidFinancialLiteracy: () => void;
};

const ViewModelContext = createContext<ViewModelContextType | undefined>(
  undefined,
);

export function ViewModelProvider({children}: {children: ReactNode}) {
  const userData = useAppSelector(selectUser);
  const {
    trackSelectOnboardingKidFinancialLiteracy,
    trackViewOnboardingKidFinancialLiteracy,
  } = useTrackers();

  useEffect(() => {
    trackViewOnboardingKidFinancialLiteracy(userData?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ViewModelContext.Provider
      value={{trackSelectOnboardingKidFinancialLiteracy}}>
      {children}
    </ViewModelContext.Provider>
  );
}

export function useViewModelProvider() {
  const context = useContext(ViewModelContext);
  if (context === undefined) {
    throw new Error('Create Journey ViewModelContext is undefined');
  }
  return context;
}
